export default {
  linkForm: {
    title: "联系表单",
    subtitle: "请填写以下信息，我们将尽快与您联系",
    firstName: "名字",
    lastName: "姓氏",
    workEmail: "工作邮箱",
    companyName: "公司名称",
    firstNamePlaceholder: "请输入您的名字",
    lastNamePlaceholder: "请输入您的姓氏",
    workEmailPlaceholder: "请输入您的工作邮箱地址",
    companyNamePlaceholder: "请输入您的公司名称",
    submitButton: "提交表单",
    submitting: "提交中...",
    resetButton: "重置表单",
    successMessage: "表单提交成功！我们将尽快与您联系。",
    errorMessage: "请检查表单填写是否正确。",
    resetMessage: "表单已重置",
    validation: {
      firstNameRequired: "请输入您的名字",
      firstNameLength: "名字长度应在1-50个字符之间",
      lastNameRequired: "请输入您的姓氏",
      lastNameLength: "姓氏长度应在1-50个字符之间",
      workEmailRequired: "请输入您的工作邮箱地址",
      workEmailFormat: "请输入正确的邮箱格式",
      companyNameRequired: "请输入您的公司名称",
      companyNameLength: "公司名称长度应在1-100个字符之间"
    }
  }
};
